export default __webpack_public_path__ + "static/media/termsOfUseAr.4df88caf.md";